import * as PIXI from "pixi.js";
import { handleViewportPanningOnDrag } from "../../pixi-components/layers/viewport/viewportPanControl";
import { getDragContext } from "../interactionEngine/dragContext";
import { spatialRegistry } from "../interactionEngine/spatialRegistry";
import {
  getInstances,
  getNodeForKey,
  getRootNode
} from "../renderingEngine/renderer";
import { renderFlags } from "./renderFlags";
import {
  getViewport,
  isViewportInitialized
} from "../../pixi-components/layers/viewport/viewport.layer";

const layoutTicker = () => {
  const instances = getInstances();
  const rootNode = getRootNode();
  if (!rootNode) return;
  if (!isViewportInitialized()) {
    return;
  }
  const viewport = getViewport();

  const dragContext = getDragContext();
  if (dragContext.node) {
    const { position } = dragContext;
    // converts nodes position to screen coordinates
    const { x, y } = viewport.toScreen(position);
    handleViewportPanningOnDrag({ pointerX: x, pointerY: y });
  }

  if (renderFlags.layoutDirty) {
    const rootComponent = instances[rootNode.key];
    rootComponent.yogaNode.calculateLayout();

    if (dragContext.node) {
      const { width, height } = dragContext.node.yogaNode.getComputedLayout();

      const originalLayoutValues = dragContext.node.getLayoutValues();
      const dragOffsetX = dragContext.position.x - dragContext.offset.x;
      const dragOffsetY = dragContext.position.y - dragContext.offset.y;
      dragContext.node.setLayoutValues({
        width,
        height,
        left: dragOffsetX - originalLayoutValues.offsetX,
        top: dragOffsetY - originalLayoutValues.offsetY,
        offsetX: originalLayoutValues.offsetX,
        offsetY: originalLayoutValues.offsetY,
        zIndex: originalLayoutValues.zIndex
      });

      spatialRegistry.update({
        key: dragContext.node.props.key,
        lastLayoutValues: originalLayoutValues,
        nextLayoutValues: dragContext.node.getLayoutValues()
      });

      function processChildren(key: string) {
        let offsetX = 0;
        let offsetY = 0;
        const node = getNodeForKey(key);
        if (!node) {
          throw Error(`Node not found for key: ${key}`);
        }
        if (node.parentKey) {
          const parentNodeInstance = getInstances()[node.parentKey];
          if (parentNodeInstance) {
            offsetX =
              parentNodeInstance.getLayoutValues().left +
              parentNodeInstance.getLayoutValues().offsetX;
            offsetY =
              parentNodeInstance.getLayoutValues().top +
              parentNodeInstance.getLayoutValues().offsetY;
          }
        }

        const instance = getInstances()[node.key];
        if (!instance) {
          throw Error(`Instance not found for key: ${node.key}`);
        }
        const lastLayoutValues = instance.getLayoutValues();
        instance.setLayoutValues({
          ...lastLayoutValues,
          offsetX,
          offsetY
        });
        spatialRegistry.update({
          key: node.key,
          lastLayoutValues,
          nextLayoutValues: instance.getLayoutValues()
        });

        node.children.forEach(child => {
          processChildren(child.key);
        });

        instance.render();
      }

      const node = getNodeForKey(dragContext.node.props.key);
      if (!node) {
        throw Error(`Node not found for key: ${dragContext.node.props.key}`);
      }

      node.children.forEach(child => {
        processChildren(child.key);
      });

      dragContext.node.render(true);
    }
    // run line-nodes rendering

    // set dirty to false
    renderFlags.layoutDirty = false;
    viewport.dirty = true;
    // objectRegistry.debug();
  }
};

const initLayoutObserver = () => {
  PIXI.Ticker.shared.add(layoutTicker);
};

const removeLayoutObserver = () => {
  PIXI.Ticker.shared.remove(layoutTicker);
};

export { initLayoutObserver, removeLayoutObserver };
